import { cx } from "~/tools/class-variance";

export const BREADCRUMB_ICON_CLASS = cx("size-[18px] brightness-[10]");
